import React from "react";
import {motion} from "framer-motion";
import Residential from "../images/Hero/Residential-image.png";
import Commercial from "../images/Hero/Comm-image.png";
import Autoimg from "../images/Hero/Auto-image.png";
import Service0 from "../images/Service Images/Service Image-0.png";
import Service1 from "../images/Service Images/Service Image-1.png";
import Service2 from "../images/Service Images/Service Image-2.png";
import Service3 from "../images/Service Images/Service Image-3.png";
import Service4 from "../images/Service Images/Service Image-4.png";
import Service5 from "../images/Service Images/Service Image-5.png";
import Service6 from "../images/Service Images/Service Image-6.png";
import Service7 from "../images/Service Images/Service Image-7.png";
import Service8 from "../images/Service Images/Service Image-8.png";
import Service9 from "../images/Service Images/Service Image-9.png";
import Service10 from "../images/Service Images/Service Image-10.png";
import {Link} from "react-router";
import Reviews from "../components/reviews";
import AutoIll from "../images/list of services/automotive.png";
import OtherIll from "../images/list of services/others.png";
import CommIll from "../images/list of services/commercial.png";
import ResiIll from "../images/list of services/residential.png";
import EnquiryTabs from "../components/inquiries/EnquiryTabs.js";
const Chip = ({children}) => {
    return (
        <div
            className="bg-gray-200 rounded-full justify-center  items-center  py-1 px-3 text-xs text-primary flex h-auto flex-col w-full">{children}</div>
    );
};
const Home = () => {
    const serviceImages = [
        {
            type: "image",
            content: Service0
        }, {
            type: "text",
            content: "Explore our wide range of residential glass solutions.",
            title: "Residential Services",
            Link: "/services/residential"
        }, {
            type: "image",
            content: Service8
        }, {
            type: "image",
            content: Service9
        }, {
            type: "text",
            content: "From windows to doors, we have you covered.",
            title: "Residential Glass",
            Link: "/services/residential"
        }, {
            type: "image",
            content: Service10
        }, {
            type: "image",
            content: Service4
        }, {
            type: "image",
            content: Service5
        }, {
            type: "image",
            content: Service6
        }, {
            type: "text",
            content: "Premium auto glass repairs and replacements,designed for your vehicle's need.",
            title: "Auto Glass",
            Link: "/services/auto"
        }, {
            type: "image",
            content: Service7
        }, {
            type: "text",
            content: "Premium automotive glass repair and replacement.",
            title: "Automotive Services",
            Link: "/services/auto"
        }, {
            type: "image",
            content: Service1
        }, {
            type: "text",
            content: "Tailored glass solutions for your unique design and functional needs.",
            title: "Custom Glass",
            Link: "/contact"
        }, {
            type: "image",
            content: Service2
        }, {
            type: "text",
            content: "Reliable glass solutions for your business.",
            title: "Commercial Services",
            Link: "/services/commercial"
        }, {
            type: "image",
            content: Service3
        }, {
            type: "text",
            content: "From storefronts to office spaces, we deliver.",
            title: "Commercial Glass",
            Link: "/services/commercial"
        }
    ];

    return (
        <div className="flex flex-col">
            {/* Hero Section */}
            <motion.div
    style={{
        height: `calc(100vh - 128px)`,
    }}
    className="bg-primary relative w-full flex flex-col md:flex-row p-4 md:p-8 gap-4 overflow-hidden"
    id="hero"
    initial={{
        opacity: 0
    }}
    animate={{
        opacity: 1
    }}
    transition={{
        duration: 1
    }}
>
    {/* Auto Section */}
    <motion.div
        className="flex-1 bg-black bg-opacity-20 flex flex-col justify-center items-center rounded-md"
        style={{
            backgroundImage: `url(${Autoimg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat"
        }}
        initial={{
            x: -100
        }}
        animate={{
            x: 0
        }}
        whileHover={{
            scale: 1.05,
            boxShadow: "0px 0px 10px rgba(0,0,0,0.5)"
        }}
        transition={{
            duration: 0.2
        }}
    >
        <Link
            to="/services/auto"
            className="w-full h-full flex flex-col justify-center items-center"
        >
            <motion.div
                whileHover={{
                    height: "100%"
                }}
                transition={{
                    duration: 0.1
                }}
                className="w-full py-4 md:py-16 bg-black bg-opacity-50 outline outline-1 outline-black backdrop-blur-md flex flex-col justify-center items-center"
            >
                <div className="text-accent text-2xl md:text-3xl font-playfair-display">Auto</div>
                <div className="text-accent text-base md:text-l font-playfair-display">Premium Automotive Glass Repairs & Replacement</div>
            </motion.div>
        </Link>
    </motion.div>

    {/* Residential Section */}
    <motion.div
        className="flex-1 bg-black bg-opacity-20 flex flex-col justify-center items-center rounded-md"
        style={{
            backgroundImage: `url(${Residential})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat"
        }}
        initial={{
            x: 100
        }}
        animate={{
            x: 0
        }}
        whileHover={{
            scale: 1.05,
            boxShadow: "0px 0px 10px rgba(0,0,0,0.5)"
        }}
        transition={{
            duration: 0.2
        }}
    >
        <Link
            to="/services/residential"
            className="w-full h-full flex flex-col justify-center items-center"
        >
            <motion.div
                whileHover={{
                    height: "100%"
                }}
                transition={{
                    duration: 0.1
                }}
                className="w-full py-4 md:py-16 bg-black bg-opacity-50 outline outline-1 outline-black backdrop-blur-md flex flex-col justify-center items-center"
            >
                <div className="text-accent text-2xl md:text-3xl font-playfair-display">Residential</div>
                <div className="text-accent text-base md:text-l font-playfair-display">Custom Glass Solutions for Your Home: Windows, Doors. and More</div>
            </motion.div>
        </Link>
    </motion.div>

    {/* Commercial Section */}
    <motion.div
        className="flex-1 bg-black bg-opacity-20 flex flex-col justify-center items-center rounded-md"
        style={{
            backgroundImage: `url(${Commercial})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat"
        }}
        initial={{
            y: 100
        }}
        animate={{
            y: 0
        }}
        whileHover={{
            scale: 1.05,
            boxShadow: "0px 0px 10px rgba(0,0,0,0.5)"
        }}
        transition={{
            duration: 0.2
        }}
    >
        <Link
            to="/services/commercial"
            className="w-full h-full flex flex-col justify-center items-center"
        >
            <motion.div
                whileHover={{
                    height: "100%"
                }}
                transition={{
                    duration: 0.1
                }}
                className="w-full py-4 md:py-16 bg-black bg-opacity-50 outline outline-1 outline-black backdrop-blur-md flex flex-col justify-center items-center"
            >
                <div className="text-accent text-2xl md:text-3xl font-playfair-display">Commercial</div>
                <div className="text-accent text-base md:text-l font-playfair-display">From Storefronts to Boardrooms: Reliable Glass Solutions</div>
            </motion.div>
        </Link>
    </motion.div>
</motion.div>


            <div
                className="flex flex-col justify-center items-center gap-8 p-8 md:p-16 bg-secondary">
                {/* Heading Section */}
                <div className="text-center">
                    <h2
                        className="text-primary text-4xl md:text-3xl font-playfair-display font-bold mb-4">
                       Redefining Glass Solutions for the Modern Era
                    </h2>
                </div>

                {/* Services Section */}
                <div
                    className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 w-full">
                    {/* Automotive Section */}
                    <div
                        className="bg-primary rounded-2xl flex flex-col justify-start items-center overflow-hidden shadow-lg">
                        <div className="w-full flex justify-start items-center py-4">
                            <h3 className="text-secondary text-2xl font-playfair-display font-bold p-2.5">Automotive</h3>
                        </div>
                        <img
                            className="w-full h-56 object-cover rounded-tr-full"
                            src={AutoIll}
                            alt="Automotive"/>
                        <div
                            className="p-4 text-secondary text-sm font-nunito-sans grid gap-4 grid-cols-2 justify-start w-full">
                            <Chip>Recalibration</Chip>
                            <Chip>Windshields</Chip>
                            <Chip>Doors Glass</Chip>
                            <Chip>Vent Glass</Chip>
                            <Chip>Quarter Glass</Chip>
                            <Chip>Back Glass </Chip>
                            <Chip>Mirrors</Chip>
                        </div>
                    </div>

                    {/* Residential Section */}
                    <div
                        className="bg-primary rounded-2xl flex flex-col justify-start items-center overflow-hidden shadow-lg">
                        <div className="w-full flex justify-start items-center py-4">
                            <h3 className="text-secondary text-2xl font-playfair-display font-bold p-2.5">Residential</h3>
                        </div>
                        <img
                            className="w-full h-56 object-cover rounded-tr-full"
                            src={ResiIll}
                            alt="Residential"/>
                        <div
                            className="p-4 text-secondary text-sm font-nunito-sans grid gap-4 grid-cols-2 justify-start w-full">
                            <Chip>Shower Enclosures</Chip>
                            <Chip>Custom Shower Designs</Chip>
                            <Chip>Frameless Shower Doors</Chip> 
                            <Chip>Frameless Sliding Doors</Chip>
                            <Chip>Fixed Panels</Chip>
                            <Chip>House Windows</Chip>
                            <Chip>Window Screens</Chip>
                            <Chip>Sunrooms</Chip>
                            <Chip>Screened In Patios</Chip>
                            <Chip>Patio Doors</Chip>
                            <Chip>Custom Table Tops</Chip>
                            <Chip>Mirrors</Chip>
                            <Chip>Cabinet Doors</Chip>
                            <Chip>Picture Frames</Chip>
                            <Chip>Frieplace</Chip>
                        </div>
                    </div>

                    {/* Commercial Section */}
                    <div
                        className="bg-primary rounded-2xl flex flex-col justify-start items-center overflow-hidden shadow-lg">
                        <div className="w-full flex justify-start items-center py-4">
                            <h3 className="text-secondary text-2xl font-playfair-display font-bold p-2.5">Commercial</h3>
                        </div>
                        <img
                            className="w-full h-56 object-cover rounded-tr-full"
                            src={CommIll}
                            alt="Commercial"/>
                        <div
                            className="p-4 text-secondary text-sm font-nunito-sans grid gap-4 grid-cols-2 justify-start w-full">

                            <Chip>Frameless Glass Solutions</Chip>
                            <Chip>Custom Showers</Chip>
                            <Chip>Sliding Patio</Chip>
                            <Chip>Swinging French</Chip>

                        </div>
                    </div>

                    {/* Custom Section */}
                    <div
                        className="bg-primary rounded-2xl flex flex-col justify-start items-center overflow-hidden shadow-lg">
                        <div className="w-full flex justify-start items-center py-4">
                            <h3 className="text-secondary text-2xl font-playfair-display font-bold p-2.5">Custom</h3>
                        </div>
                        <img
                            className="w-full h-56 object-cover rounded-tr-full"
                            src={OtherIll}
                            alt="Custom"/>
                        <div
                            className="p-4 text-secondary text-sm font-nunito-sans grid gap-4 grid-cols-2 justify-start w-full">

                            <Chip>Custom Designs</Chip>
                            <Chip>Specialty Glasswork</Chip>
                            <Chip>Custom Glass Installations</Chip>
                            <Chip>Personalized Solutions</Chip>
                        </div>
                    </div>
                </div>
            </div>
            <motion.div
                className="w-full bg-primary py-12 md:py-24"
                initial={{
                    opacity: 0
                }}
                animate={{
                    opacity: 1
                }}
                transition={{
                    duration: 1
                }}>
                <h2
                    className="text-accent text-4xl md:text-6xl font-playfair-display text-center mb-8">
                    Discover Our Services
                </h2>
                <div
                    className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 px-4 md:px-8">
                    {
                        serviceImages.map((item, i) => (
                            <motion.div
                                key={i}
                                className="h-32 md:h-48 w-full flex flex-col items-start justify-start rounded-md overflow-hidden"
                                initial={{
                                    scale: 0.8
                                }}
                                animate={{
                                    scale: 1
                                }}
                                whileHover={{
                                    scale: 1.1
                                }}
                                transition={{
                                    duration: 0.5
                                }}>
                                {
                                    item.type === "image"
                                        ? (
                                            <img
                                                src={item.content}
                                                alt={`Service ${i + 1}`}
                                                className="h-full w-full object-cover shadow-2xl "/>
                                        )
                                        : (
                                            <Link to={item.Link} className="text-center p-4">
                                                <h3 className="text-secondary text-lg font-bold text-left">{item.title}</h3>
                                                <p className="text-accent text-sm text-left">{item.content}</p>
                                            </Link>
                                        )
                                }
                            </motion.div>
                        ))
                    }
                </div>
            </motion.div>
            <div
                className="flex flex-col justify-center items-center gap-4 p-8 md:p-24 bg-secondary">

                <Reviews/>
            </div>
           <EnquiryTabs/>
        </div>
    );
};

export default Home;